/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { Box, Card, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ThaiQrPayment from '../../assets/images/thai_qr_payment.png';
import HeadQrPayment from '../../assets/images/thai_qr_payment1.png';
import SecondQrPayment from '../../assets/images/CreditCardImage1.png';
import api from '../../utils/functions/api';
import { getStorage } from '../../utils/functions/localstorage';

const QRCredit = ({
  language = 'TH',
  qrCodeImage: propQrCodeImage,
  paymentRefId: propPaymentRefId,
  payment_token: propPaymentToken,
  orderId: propOrderId,
  companyName,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  // รองรับทั้งจาก props และจาก location.state
  const {
    qrCodeImage = propQrCodeImage,
    paymentRefId = propPaymentRefId,
    payment_token = propPaymentToken,
    orderId = propOrderId,
  } = location.state || {};

  const intervalRef = useRef(null);
  const checkInterval = useRef(null);
  const [intervalId, setIntervalId] = useState(null);

  const checkPaymentRefId = async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_APIHOST}/check_callback`,
        { headers: { Authorization: payment_token, sub: paymentRefId } },
      );
      if (response.status === 200) {
        const { rmsg, status, tagUrl, tagInput } = response.data;
        if (rmsg === 'pending') {
          navigate(`/transactionResultEEntry?status=${rmsg}`);
        }
        if (rmsg === 'cancel') {
          clearInterval(intervalId);
          navigate(`/transactionResultEEntry?status=${rmsg}`);
        }
        clearInterval(intervalId);
        if (status === 'call merchant' || status === 'call merchant jwt') {
          clearInterval(intervalId);
          submitFormToMerchant(tagUrl, tagInput);
        } else if (status === 'do not call merchant') {
          clearInterval(intervalId);
          const etaxResponse = await api.post(
            `${process.env.REACT_APP_APIHOST}/etax/signandgetdocument`,
            { paymentRef: paymentRefId },
          );
          const data2 = etaxResponse.data || '';
          if (data2.status === 'OK') {
            const urlPDF = data2.pdfURL;
            window.location.replace(
              `/transactionResultEEntry?status=${rmsg}&urlPDF=${encodeURIComponent(
                urlPDF || '',
              )}`,
            );
          } else {
            window.location.replace(`/transactionResultEEntry?status=${rmsg}`);
          }
        }
      }
    } catch (error) {
      console.error('Error during combined API call:', error);
    }
  };

  useEffect(() => {
    return () => {
      if (checkInterval.current) {
        clearInterval(checkInterval.current);
      }
    };
  }, []);

  useEffect(() => {
    let interval;
    if (paymentRefId) {
      checkPaymentRefId();
      interval = setInterval(checkPaymentRefId, 10000);
    }
    return () => clearInterval(interval);
  }, [paymentRefId]);

  return (
    <Box
      sx={{
        maxWidth: '600px',
        margin: '0 auto',
        padding: '24px',
        borderRadius: '15px',
        backgroundColor: '#fff',
        boxShadow: 3,
        justifyContent: 'center',
        justifyItems: 'center',
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        gutterBottom
        sx={{ textAlign: 'center' }}
      >
        {language === 'TH' ? 'QR Visa Mastercard' : 'Pay via QR Code'}
      </Typography>

      <Box
        sx={{
          maxWidth: '400px',
          minHeight: '450px',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          border: '1px solid #00427A',
          borderRadius: '15px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '20px',
            zIndex: 3,
          }}
        >
          <img
            src={HeadQrPayment}
            alt="Thai QR Payment"
            style={{
              width: '100%',
              maxWidth: '400px',
              borderTopLeftRadius: '12px',
              borderTopRightRadius: '12px',
            }}
          />
          <img
            src={SecondQrPayment}
            alt="Credit Card"
            style={{ width: '35%', maxWidth: '400px', marginTop: '10px' }}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {qrCodeImage ? (
            <>
              <img
                src={qrCodeImage}
                alt="QR Code"
                style={{
                  width: 200,
                  height: 200,
                  objectFit: 'contain',
                }}
              />
              <Box sx={{ marginTop: 2 }}>
                <a
                  href={qrCodeImage}
                  download={`QR_${companyName || 'PromptPay'}_${
                    orderId || 'order'
                  }.png`}
                  style={{
                    textDecoration: 'none',
                    backgroundColor: '#00427A',
                    color: 'white',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    display: 'inline-block',
                  }}
                >
                  {language === 'TH' ? 'ดาวน์โหลด QR' : 'Download QR'}
                </a>
              </Box>
            </>
          ) : (
            <Typography>ไม่พบ QR Code</Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default QRCredit;
